<template>
    <div class="custom-shadow ph3 ph4-ns pv4">
        <ImageLabel>
            <Textbox @keyup.enter="send()" v-model="text" placeholder="Send a message..."/>
            <div @click="send()" class="b--mid-gray grow pointer ph3 th flex items-center">
                <img :src="getImage()">
            </div>
        </ImageLabel>
    </div>
</template>
    
<script>
import ImageLabel from '@/components/controls/ImageLabel.vue';
import Textbox from '@/components/controls/Textbox.vue';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            text: ''
        };
    },
    components: {
        ImageLabel,
        Textbox
    },
    props: {
        contactId: {
            type: Number
        }
    },
    methods: {
        ...mapActions('messages', ['sendMessage']),
        getImage() {
            return this.text === ''
                ? require(`@/assets/img/icon_send_inactive.svg`)
                : require(`@/assets/img/icon_send_active.svg`);
        },
        send() {
            if (this.text !== '') {
                this.sendMessage({
                    text: this.text,
                    contactId: this.contactId
                });
                this.text = '';
            }
        }
    }
};
</script>
